import styled from 'styled-components';
import { COLORS } from 'utils/constants/styles';

const StyledText = styled.span`
    color: ${props => props.theme.background.theme || COLORS.BUTTON_BACKGROUND};
`;

type Props = {
    children: string;
};

const PinkText = ({ children }: Props) => <StyledText>{children}</StyledText>;

export default PinkText;
